// extracted by mini-css-extract-plugin
export default {"fourColPlus":"fourColPlus-inogH","loadMore":"loadMore-D1MZ7"};